import { Verification } from "../../../services/verifyService/model";
import { CompositeSpecification } from "../../../utils/Specification";

export class CoInsMustBeLessThan100Percent extends CompositeSpecification<Verification>{
    IsSatisfiedBy(candidate: Verification): boolean {
        return Number(candidate.benefits.coInsurance) <= 100;
    }

}